<template>
    <client-page className="header--light">
        
        <sub-visual
        sh="기업소개"
        sh2="기업문화"
        tabActive="기업문화"
        bg="/images/sub/visual/sv1-5.jpg">
        </sub-visual>

        <div class="text-center color-white bg-point py-50 py-lg-74 w-100">
            <v-container>
                <h3 class="tit font-weight-light font-italic" data-aos="fade-down">
                    함께여서 즐거운 <strong class="font-weight-bold">세일즈웍스 코리아</strong>
                </h3>
                <p class="tit-txt mt-10 mt-lg-24" data-aos="fade-up">
                    긍정적인 에너지를 나누며 함께 문화를 만들어가는 세일즈웍스는 <br class="d-none d-md-block">
                    다양한 경험을 통해 하루하루 성장해나가고 있습니다.
                </p>
            </v-container>
        </div>

        <section class="section--sm section--last">
            <v-container>
                <company-culture />
            </v-container>
        </section>
        
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import CompanyCulture from "@/components/client/business/company-culture.vue";
export default {
    components: {
        ClientPage,
        CompanyCulture,
        SubVisual
    },
    data() {
        return {
            filter: {
                category: null
            }
        }
    }
};
</script>

